import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import TableTop from "../../../Components/UI/TableTop";
import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import CpfContributionModal from "Components/Modal/master/CpfContributionModal";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ToastNotification from "Components/UI/ToastNotification";
import { all_routes } from "Router/all_routes";
import {
  useDeletePaymodeMutation,
  useGetPaymodeQuery,
  useInsertPaymodeMutation,
  useUpdatePaymodeMutation,
} from "AppQuries/master/Paymode/pay-mode";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import PaymodeModal from "Components/Modal/master/PaymodeModal";
import { yupResolver } from "@hookform/resolvers/yup";
import { paymodeValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import ReportTools from "Components/UI/ReportTools";
import { BackIcon } from "Components/UI/Icon/Icons";
import { toast } from "core/Operations/toast";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Popconfirm } from "antd";
const Paymode = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetPaymodeQuery({
    companyCode: userData?.companyCode,
    isTrue: showActiveOnly,
  });
  const methods = useForm({
    resolver: yupResolver(paymodeValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem } = useInsertPaymodeMutation();
  const { mutate: updateItem } = useUpdatePaymodeMutation();
  const {mutate: deleteItem} = useDeletePaymodeMutation();
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const deleteItemHandler = (item) => {
  const payload = {
    companyCode: item.companyCode,
    paymentCode: item.paymentCode,
    paymentMode: item.paymentMode,
    createUser: item.createUser,
    createDate: item.createDate,
    modifyUser: userData.userName,
    modifyDate: getCurrentFormattedDate(),
    isActive: false
  };

  deleteItem(payload, {
    onSuccess: (data) => {
      if (data) {
        toast.success("Paymode Deleted Successfully.");
        GetItems();
      } else {
        toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
      }
    },
    onError: (error) => {
      toast.error(error.message || "Something went wrong.");
    }
  });
};

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      paymentCode: 0,
      paymentMode: "",
      isActive: true,
      createUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      paymentCode: item.paymentCode,
      paymentMode: item.paymentMode,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    console.log(payload);
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          console.log(data);
          if (data) {
            toast.success(data?.[0]?.errorMessage || "Updated Successfully.");
            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          if (data?.[0]?.response) {
            toast.success(data?.[0]?.errorMessage || "Created Successfully.");
            setShow(false);
            GetItems();
          } else {
            toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text}</>,
    },

    {
      title: "PayMode",
      dataIndex: "paymentMode",
      sorter: (a, b) => a.paymentMode.length - b.paymentMode.length,
    },

    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
            <Can
              accessModule={accessCodes.master}
              accessCode={accessCodes.master_paymode}
              accessType="haveEdit"
            >
              <Link
                className="me-2 p-2"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </Can>
            <Can
              accessModule={accessCodes.master}
              accessCode={accessCodes.master_paymode}
              accessType="haveDelete"
            >
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
              >
                <Link className="me-2 p-2" to="#">
                  <Popconfirm
                    title="Are you sure to Delete?"
                    onConfirm={() => deleteItemHandler(record)}
                  >
                    <Trash2 className="feather-delete" />
                  </Popconfirm>
                </Link>
              </OverlayTrigger>
            </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Paymode Management</h4>
                <h6>Manage Compnay Payment Methods</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Paymode Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetItems}
              />
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_paymode}
                accessType="haveAdd"
              >
                <Link to="#" className="btn btn-added" onClick={handleAddClick}>
                  <PlusCircle className="me-2" />
                  Add Payment Method
                </Link>
              </Can>
              &nbsp;
              <Link to={`${all_routes.master}`} className="btn btn-secondary">
                <BackIcon className="me-2" />
                Back
              </Link>
            </div>
          </div>
          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <PaymodeModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default Paymode;
